import { Chip, IconButton, Tooltip } from "@mui/material";
import React, { useRef, useState } from "react";
import { Button, CardHeader, Table } from "reactstrap";
import DeleteIcon from '@mui/icons-material/Delete';
import { DeleteOutline } from "@mui/icons-material";

const AgreementTable = (props) => {
  const {
    editable,
    tableData,
    displayTableData,
    setDisplayTableData,
    agreementData,
    setAgreementData,
  } = props;
  

  // const sellingPriceRef = useRef("");

  const handleSellingPrice = (event, variantId, itemId,alternateItemTitle) => {
    const { value } = event.target;

    const updatedDisplayTableData = displayTableData.map((data) => {
      if (data.id === variantId&&data.alternateItemTitle===alternateItemTitle) {
        return { ...data, sellingPrice: value };
        
      }
      return data;
    });

    setDisplayTableData(updatedDisplayTableData);

    const updatedAgreementData = agreementData.map((agreement) => {
      if (agreement.item === itemId&&agreement.alternateItemTitle===alternateItemTitle) {
        const updatedVariants = agreement.variants.map((variant) => {
          if (variant.variant === variantId) {
            return { ...variant, price: value };
          }
          return variant;
        });
        return { ...agreement, variants: updatedVariants };
      }
      return agreement;
    });

    setAgreementData(updatedAgreementData);
  };

  const handleDeleteAgreement = (variantId,alternateItemTitle) => {
    const newArr = displayTableData.filter((e) => {
      if(e.alternateItemTitle===alternateItemTitle)
      {
        return e.id !== variantId
      }
      return true
  
    });
    setDisplayTableData(newArr);

    const updatedAgreementData = agreementData
      .filter((agreement) => {
       // const updatedVariants = agreement.variants.filter(
          //(variant) => variant.variant === variantId
        //);
        //if (updatedVariants.length === 0) {
          // Remove the entire agreement object if variants array becomes empty
         // return null;
        //} else {
         // return { ...agreement, variants: updatedVariants };
        //}
        return agreement.alternateItemTitle!==alternateItemTitle
       
      })
      .filter(Boolean); // Filter out null values
    setAgreementData(updatedAgreementData);
  };

const handleAlternativeItemChange = (event, itemId,alternateItemTitle) => {
  const { value } = event.target;

  const updatedDisplayTableData = displayTableData.map((data) => {
    if (data.itemId === itemId&&data.alternateItemTitle===alternateItemTitle) {
      return {
        ...data,
        alternateItemTitle: value,
      };
    }
    return data;
  });

  setDisplayTableData(updatedDisplayTableData);

  const updatedAgreementData = agreementData.map((agreement) => {
    if (agreement.item === itemId&&agreement.alternateItemTitle===alternateItemTitle) {
      return {
        ...agreement,
        alternateItemTitle: value,
      };
    }
    return agreement;
  });

  setAgreementData(updatedAgreementData);
};


  return (
    <Table>
      <thead>
        <tr>
          <th>Product Name</th>
          <th style={{width:'20%'}}>Description</th>
          <th style={{ width: '20%' }}>Cost</th>
          <th>Tax Bracket</th>
          {editable && <th>Action</th>}
        </tr>
      </thead>
      <tbody id="agreementBody">
        {editable ? 
          displayTableData?.length > 0
            ? displayTableData.map((data) => (
              <tr key={data.id} style={{ verticalAlign: 'middle' }}>
                <td>
                  <span>{data.title}</span>
                  <div style={{ display: 'flex', gap: '3px' }}>
                    {data.type === 'variable' ?
                      data.attributes.map((attribute, index) => (
                        <Chip size="small" key={index} label={`${attribute.name}: ${attribute.value}`} />
                      )) : null
                    }
                  </div>
                </td>
                {editable?(
                <td>
                <input
                type="text"
                className="form-control"
                value={
                  data.alternateItemTitle
                }
                style={{borderColor:  'black'}}
                onChange={(e) => handleAlternativeItemChange(e, data.itemId,data.alternateItemTitle)}
                />
                </td>
                ):
                <td>
                  {data.alternateItemTitle}
                </td>
              }
              
                {editable ? (
                  <td>
                    <input
                      type="number"
                      value={data?.sellingPrice || ""}
                      className="form-control"
                      style={{
                        borderColor: data.sellingPrice <= 0 || !data.sellingPrice ? 'red' : 'black'
                      }}
                      onChange={(event) => {
                        handleSellingPrice(event, data.id, data.itemId,data.alternateItemTitle);
                      }}
                    />
                  </td>
                ) : (
                  <td >₹{`${data?.sellingPrice}/per ${data.unit}` || ""}</td>
                )}
                <td >{data?.tax}</td>
                {editable ? (
                  <td>
                    <Tooltip title="Delete" arrow placement="right">
                      <IconButton aria-label="delete" size="small" color="error" onClick={() => {
                        handleDeleteAgreement(data.id,data.alternateItemTitle);
                      }}>
                        <DeleteOutline fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </td>
                ) : null}
              </tr>
            ))
            : null
          : tableData?.length > 0 
            ?
              tableData.map((data) => (
                <tr key={data.id} style={{ verticalAlign: 'middle' }}>
                  <td>
                    <span>{data.title}</span>
                    <div style={{ display: 'flex', gap: '3px' }}>
                      {data.type === 'variable' ?
                        data.attributes.map((attribute, index) => (
                          <Chip size="small" key={index} label={`${attribute.name}: ${attribute.value}`} />
                        )) : null
                      }
                    </div>
                  </td>
                   <td>
                  {data.alternateItemTitle||""}
                </td>
                  <td >₹{`${data?.sellingPrice}/per ${data.unit}` || ""}</td>
                  <td >{data?.tax}</td>
                </tr>)) 
            : null}
      </tbody>
    </Table>
  );
};

export default AgreementTable;
